export default __webpack_public_path__ + "static/media/tts_en_head_a1(-8).49cc8112.mp3";